export function updateCulture(cultureName: string) {
    localStorage.setItem("Culture", cultureName);
}

export function getCulture() {
    return localStorage.getItem("Culture") ?? "";
}